module.exports = __webpack_public_path__ + "img/icon_recipes_button.ai.a499a18b.svg";